export default function () {
	/* eslint-disable */
	const sectorMenu = document.getElementById('sectormenu');

	var isChromium = false;
	if (navigator.userAgent.indexOf("Chrome") != -1) {
		isChromium = true;
	}

	if (sectorMenu) {
		const body = document.getElementsByTagName('BODY')[0];
		const sectorButtons = [...sectorMenu.querySelectorAll('a')];
		const sectorSections = [...document.querySelectorAll('[data-section]')];
		let activeSection = null;
		let boolScrollSectorMenu = true;
		const duration = 2500;

		body.classList.add('page-subsector');

		sectorButtons.forEach((item) => {
			const section = document.getElementById(item.dataset.anchorbtn);

			if (section) {
				item.addEventListener('click', (event) => {
					event.preventDefault();
					boolScrollSectorMenu = false;

					sectorButtons.forEach(item => {
						item.classList.remove('act');
					});

					item.classList.add('act');

					sectorMenu.scrollTo({
						top: 0,
						left: item.offsetLeft - 20,
						behavior: 'smooth'
					});

					section.scrollIntoView();

					setTimeout(() => {
						boolScrollSectorMenu = true;
					}, duration);

				});
			}
			else
			{
				item.classList.add('hidden');
			}
		});

		const spyScrolling = () => {
			function getHeaderOffset() {
				const bodyWidth = document.documentElement.clientWidth;
				if (bodyWidth > 1280) return 190; // XL
				return 60;
			}

			let sectorSectionsOffsets = sectorSections.map(e => e.offsetTop);
			let sectorNextSectionOffset = sectorSections.map(e => e.offsetTop);
			sectorNextSectionOffset.shift();
			sectorNextSectionOffset.push(-1);

			window.onresize = () => {
				sectorSectionsOffsets = sectorSections.map(e => e.offsetTop);
				sectorNextSectionOffset = sectorSections.map(e => e.offsetTop);
				sectorNextSectionOffset.shift();
				sectorNextSectionOffset.push(-1);
			};

			window.onscroll = () => {
				const scrollPos = (document.documentElement.scrollTop || document.body.scrollTop) + getHeaderOffset() + (document.documentElement.clientHeight / 3);

				function checkNextSection(i) {
					const nextOffset = sectorNextSectionOffset[i];
					if (scrollPos < nextOffset || nextOffset === -1) return true;
					return false;
				}

				for (let i = 0; i < sectorSectionsOffsets.length; i++) {
					if (scrollPos < sectorSectionsOffsets[0]) {
						const sectionId = null;

						if (activeSection !== sectionId) {
							activeSection = sectionId;

							sectorButtons.forEach(item => {
								item.classList.remove('act');
							});

							if (!isChromium) {
								sectorMenu.scrollTo({
									top: 0,
									left: 0,
									behavior: 'smooth'
								});
							}
						}
					}
					else if (scrollPos >= sectorSectionsOffsets[i] && checkNextSection(i)) {
						const sectionId = sectorSections[i].id;
					
						if (activeSection !== sectionId) {
							activeSection = sectionId;
					
							if (boolScrollSectorMenu) {
								sectorButtons.forEach(item => {
									item.classList.remove('act');
								});
								sectorButtons[i].classList.add('act');

								if (!isChromium) {
									sectorMenu.scrollTo({
										top: 0,
										left: sectorButtons[i].offsetLeft - 20,
										behavior: 'smooth'
									});
								}
							}
							break;
						}
					}
				}
			};
		};
		setTimeout(function () {
			spyScrolling();
		}, 200);
	}
	/* eslint-enable */
};
